import { getInfo, TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters';

export default function TextFormatter({ info, value: propsValue }) {
  const { value } = getInfo(info)
  const text = propsValue || value

  return <TruncateWithTooltipFormatter value={text} />
}
